// extracted by mini-css-extract-plugin
export default {"container":"MN-z","error":"NN-z","disabled":"ON-z","submit":"PN-z","option":"QN-z","success":"RN-z","failure":"SN-z"};